import React from 'react';
import PropTypes from 'prop-types';
import secm from '@baidu/sec-monitor';
import {pzCardinfo} from '../../actions/businessCard.js';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {Button} from '@baidu/spui';
import Popover from 'antd/lib/popover';
import {Swiper, SwiperSlide} from 'swiper/react';
import iconScan from '../../asset/img/scan.svg';
import './newCard.less';
import {getUrlValue} from '../../util';

export class PzCard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            company: {},
            current: 0,
        };
    }
    componentDidMount() {
        const cn = decodeURIComponent(getUrlValue('company-name'));
        this.init(cn);
    }

    onSlideChange(e) {
        this.setState({
            current: e.activeIndex
        });
    }
    init(cn) {
        window.BCat_2055 && window.BCat_2055.miao();
        /* eslint-disable */
        window['__abbaidu_2055_cb'] = responseData => {
            window['__abbaidu_2055_cb'] = null;
            let localData = JSON.parse(responseData);
            this.props.pzCardinfo({
                'company_name': cn,
                data: localData.data,
                'key_id': localData['key_id'],
                sign: localData.sign
            }).then((res) => {
                const resp = res.data || {};
                // resp.detailed_loc = resp.detailed_loc && JSON.parse(resp.detailed_loc);
                resp.detailed_loc = resp.company_addr;
                resp.open_info = resp.open_info;
                resp.company_adverts = resp.company_adverts && resp.company_adverts.split(';');
                this.setState({
                    company: resp
                });
            });
        };
        /* eslint-enable */
    }
    renderOpenInfo = () => {
        const {company = {}} = this.state;
        let openInfo = [];
        if (!company.open_info) {
            return '';
        }
        if (Array.isArray(company.open_info)) {
            openInfo = company.open_info;
        } else {
            openInfo = [company.open_info];
        }
        let result = [];
        if (openInfo.length === 0) {
            result = ['全天'];
        } else {
            result = openInfo.map((v) => {
                return (v.day_range + '：' + v.open_time + '-' + v.close_time);
            });
        }
        return result;
    };

    render() {
        const {company = {}} = this.state;
        const qrcodeUrl = (
            window.location.host.indexOf(':8066') > -1
            || window.location.host.indexOf('safe-mobsec06.bcc-bdbl.baidu.com') > -1)
            ? 'http://safe-mobsec06.bcc-bdbl.baidu.com:8879' : 'https://mhaoma.baidu.com';
        /* eslint-disable */
        const qrCode = <img className='qr-code' src={window.location.origin
            + '/api/v1/qr_code?url='
            + encodeURIComponent(
            `${qrcodeUrl}/pages/pz-card/pz-card?company_name=${company.company_name}&scan=true`
        )}></img>
        const isBaidu = company.company_id === 38951;
        const openInfo = this.renderOpenInfo();
        return (
            <div className="business-card">
                <div className="business-card-swiper">
                    <Swiper
                        slidesPerView={1}
                        style={{position: 'relative'}}
                        autoplay={true}
                        className={'business-card-swiper-box'}
                        onSlideChange={(e) => {
                            this.onSlideChange(e);
                        }}
                        pagination={{
                            clickable: true,
                            el: '.swiper-pagination1',
                            bulletClass: 'my-bullet',
                            bulletActiveClass: 'my-bullet-active'
                        }}
                        navigation={{
                            nextEl: '.swiper-button-next1',
                            prevEl: '.swiper-button-prev1'
                        }}
                    >
                        {company.company_adverts
                        && company.company_adverts.map((item, i) => {
                            return (
                                <SwiperSlide key={i}>
                                    <div className="swiper-box">
                                        <img
                                            className={'swiper'}
                                            src={item}
                                            alt=""
                                        />
                                    </div>
                                </SwiperSlide>);
                        })}
                        <div className="swiper-btn">
                            <div className={company.company_adverts
                            && company.company_adverts.length === 1
                                ? 'swiper-pagination1 my-button-hidden' : 'swiper-pagination1'}></div>
                        </div>
                    </Swiper>
                </div>
                <div className="business-card-info">
                    <p className={'title'}>
                        {company.business_card_display || company.company_name}
                    </p>
                    {company.detailed_loc
                    && <div>
                        <div className={'company-info'}>
                            <div className={'msg_left'}>
                                <img
                                    className={'icon'}
                                    src={require('../../asset/img/businessCard/location.png')}
                                    alt=""
                                />
                                <span className={'ms'}>地址：</span>
                            </div>
                            <div className={'msg_right'}>
                                <p style={{fontFamily: 'PingFangSC-Medium'}} className={'pddr'}>
                                    {company.detailed_loc}
                                </p>
                            </div>
                        </div>
                    </div>
                    }
                    {company.phones?.length > 0 && <p className={'bord'}></p>}
                    <div className={'mt22 phone-detail'}>
                        <div>
                            <img
                                className={'icon'}
                                src={require('../../asset/img/businessCard/phone.png')}
                                alt=""
                            />
                            <span className={'kftxt'}>企业官方号码</span>

                            {!isBaidu && <div className={'serviceTime'}>接通时间：{openInfo}</div>}
                        </div>
                        <div className='phonebox-wrapper'>
                            {
                                company.phones && company.phones.map((item, i) => {
                                    const phoneArr = item.phone.split(';');
                                    const basePhone = phoneArr[0];
                                    return (
                                        <div
                                            key={i}
                                            className={'phonebox'}
                                            style={{marginTop: '12px'}}
                                        >
                                            <span className={'ms bl'}>
                                                {item.display}
                                            </span>
                                            <span className={'phone'}>
                                                {basePhone + (phoneArr[1] ? '转' + phoneArr[1] : '')}
                                            </span>
                                        </div>
                                    );
                                })
                            }
                            <Popover
                                overlayClassName="scan-popover"
                                trigger="hover"
                                content={qrCode}
                                placement="left"
                            >
                                <button className='scan-btn'>
                                    <img
                                        style={{'verticalAlign': 'bottom', marginRight: '5px'}}
                                        src={iconScan}
                                    ></img>
                                    <span>扫码拨号</span>
                                </button>
                            </Popover>
                        </div>

                    </div>
                    <div className="bottom-btn-wrapper">
                        <Button
                            label={'去认证我的企业号码'}
                            styleType={'ghost'}
                            className={'gorz'}
                            onClick={() => {
                                _hmt.push(['_trackEvent', 'pzcard', company.company_name, 'goattest']);
                                secm.action('pzcard', company.company_name, 'goattest');
                                this.props.history.push('/attest/simple');
                            }}
                        >
                        </Button>
                    </div>
                </div>
            </div>
        );
    }
}
PzCard.propTypes = {
    history: PropTypes.object,
    location: PropTypes.any,
    pzCardinfo: PropTypes.func,
    userInfo: PropTypes.object,
    submitEvaluation: PropTypes.func,
};

function mapDispatchToProps(dispatch) {
    return {
        pzCardinfo: obj => pzCardinfo(dispatch, obj),
    };
}

function mapStateToProps(state) {
    return {
        userInfo: state.userInfo
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PzCard));